import { MigrationType } from "../dto/migration-type.enum";
import { StructureVector } from "./structure-vector.model";

	/**
	 * @description
	 *  Modelo de una migración de la estructura comercial.
	 *
	 * @see gigot-backend/Core/Query/CommercialStructureMigration.cs
	 */

export class CommercialStructureMigration {

	public destination: StructureVector;
	public migrationType: MigrationType;
	public source: StructureVector;

	/**
	 * @description
	 *	Construye una migración de estructura con una semántica vacía. Nótese
	 *	que no es lo mismo que construir una migración con valores por
	 *	defecto. Las reglas generales de construcción son:
	 *
	 *      - Campos 'array' se definen como [].
	 *      - Campos 'boolean' se definen como 'false'.
	 *      - Campos 'Date' se definen como 'undefined'.
	 *      - Campos 'enum' se definen como 'undefined'.
	 *      - Campos 'number' se definen como 'undefined'.
	 *      - Campos 'string' se definen como '' (cadena vacía).
	 *      - Campos 'object' se definen llamando a su propio método #empty().
	 *      - Campos de la superclase se definen al igual que campos 'object'.
	 *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
	 *
	 * @returns
	 *	Una migración vacía.
	 */
	public static empty(): CommercialStructureMigration {
		const commercialStructureMigration: CommercialStructureMigration = new CommercialStructureMigration();
		commercialStructureMigration.destination = StructureVector.empty();
		commercialStructureMigration.source = StructureVector.empty();
		commercialStructureMigration.migrationType = undefined;
		return commercialStructureMigration;
	}

	/**
	 * @description
	 *  Método de reificación de un modelo compatible anémico. Esto permite
	 *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
	 *  valor de sus propiedades se mantiene.
	 *
	 * @param anemicIndicator
	 *  El modelo anémico a reificar.
	 *
	 * @returns
	 *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
	 *  profundidad desde el modelo anémico.
	 */
	public static from(anemicCommercialStructureMigration: CommercialStructureMigration): CommercialStructureMigration {
		if (!anemicCommercialStructureMigration) return undefined;
		const commercialStructureMigration: CommercialStructureMigration = CommercialStructureMigration.empty();
		commercialStructureMigration.destination = StructureVector.from(anemicCommercialStructureMigration.destination);
		commercialStructureMigration.source = StructureVector.from(anemicCommercialStructureMigration.source);
		commercialStructureMigration.migrationType = anemicCommercialStructureMigration.migrationType;
		return commercialStructureMigration;
	}
}
